module.exports = __webpack_public_path__ + "img/egg_fish_happy.2f90f042.svg";